import { Selector } from '@ngxs/store';
import { MatterDocumentSelectors } from '@state/matter/documents/documents.selectors';
import { MatterFolderSelectors } from '@state/matter/folders/folders.selectors';

export class DocumentAndFoldersLoaded {
	// Check whether all documents and folders have been already fetched from the DB or not.
	@Selector([MatterDocumentSelectors.getLoading])
	static areDocumentsAndFoldersLoading(
		matterFoldersLoading: boolean,
		matterDocumentsLoading: boolean,
	): boolean {
		return matterFoldersLoading || matterDocumentsLoading;
	}
}
